import { render } from "./management.cattle.io.clusterroletemplatebinding.vue?vue&type=template&id=b42bc2fa"
import script from "./management.cattle.io.clusterroletemplatebinding.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.clusterroletemplatebinding.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__